import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  paddedLink: {
    padding: [[14, 32]],
  },
});

export default useStyles;
